// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yttM","colMin":"styles_colMin__3AGJe"};